import permissions from '@/enums/permissions';

const rentValidator = [
    {
        path: '/Validacao-aluguel',
        name: 'rent-validator',
        component: () => import('@/views/pages/RentValidator/RentValidator.vue'),
        meta: {
            permissions: permissions.rentValidator,
        },
    },
];

export default rentValidator;
